import { initializeApp } from "firebase/app";
import { showDialog, showConfirmDialog } from "vant";
import { driverAxios } from "./axios";

// **获取 APP 版本**
const APP_VERSION = __APP_VERSION__;
const LAST_VERSION = localStorage.getItem("APP_VERSION");

console.log("云版本号：" + APP_VERSION);
console.log("本地版本号：" + LAST_VERSION);

const swUrl = `/firebase-messaging-sw.js?v=${__APP_VERSION__}`;

// **如果版本变化，清理缓存 & 更新 Service Worker**
if (LAST_VERSION !== APP_VERSION) {
  console.log(`🚀 发现新版本: ${APP_VERSION}，清除缓存并更新 Service Worker`);
  localStorage.setItem("APP_VERSION", APP_VERSION);

  // **清除缓存**
  if ("caches" in window) {
    caches.keys().then((names) => {
      names.forEach((name) => caches.delete(name));
    });
  }

  // **更新 Service Worker**
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.update(); // 🔄 强制检查新版本
      });
    });
  }
  if(LAST_VERSION == null){
    showDialog({
      title: "⏳ 正在初始化",
      message: "欢迎使用iDirect骑手端，应用正在加载中",
      showConfirmButton: false,
      closeOnClickOverlay: false,
    });
  } else {
    showDialog({
      title: "🚀 发现新版本",
      message: "请稍候，正在自动升级iDirect骑手端",
      showConfirmButton: false,
      closeOnClickOverlay: false,
    });
  }
  
  setTimeout(() => {
    window.location.reload();
  }, 3000);
}else{
  console.log("✅ APP版本最新");
}

// Firebase 配置
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// 初始化 Firebase
const app = initializeApp(firebaseConfig);

if (LAST_VERSION !== APP_VERSION) {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register(swUrl).then((registration) => {
      console.log("🔥 Service Worker 重新注册成功:", registration);
  
      registration.addEventListener("updatefound", () => {
        console.log("🔄 发现新的 Service Worker 版本");
        const newWorker = registration.installing;
  
        newWorker.addEventListener("statechange", () => {
          if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
            console.log("⚠️ 新版本可用，强制跳过等待");
            newWorker.postMessage({ action: "skipWaiting" });
            showDialog({
              title: "🚀 发现新版本",
              message: "请稍候，正在自动升级iDirect骑手端",
              showConfirmButton: false,
              closeOnClickOverlay: false,
            });
          }
        });
      });
    }).catch((err) => console.log("❌ Service Worker 注册失败:", err));
  }
  
  // **监听 `controllerchange`，确保 SW 切换后才刷新**
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    console.log("✅ Service Worker 已激活，刷新页面");
    setTimeout(() => {
      window.location.reload();
    }, 3000);
  });
}

// **判断是否在 PWA 里运行**
function isPWA() {
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}

// **Web Push 订阅**
const subscribeToPush = async () => {
  try {
    
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: import.meta.env.VITE_VAPID_PUBLIC_KEY,
    });

    console.log("📌 订阅成功:", subscription);

    await driverAxios.post("/api/driver/subscribePushV1", {
      subscribeData: subscription,
      appVersion: __APP_VERSION__,
    });

    // showDialog({
    //   title: "通知开启成功",
    //   message: "✅ 你已成功开启通知权限！",
    // });

  } catch (error) {
    console.error("❌ 订阅失败:", error);
    showDialog({
      title: "订阅失败",
      message: "⚠️ 无法订阅通知，请稍后重试。",
    });
  }
};

// **使用 Web Push API 订阅通知**
export const requestPermission = async () => {
  if (!("Notification" in window) || !("serviceWorker" in navigator)) {
    showDialog({
      title: "❌ 设备不支持",
      message: "设备不支持消息通知，请使用应用进行访问",
    });
    console.error("❌ 设备不支持通知或 Service Worker");
    return;
  }

  // 如果不是 PWA，提示用户安装
  // if (!isPWA()) {
  //   showDialog({
  //     title: "📲 请安装应用",
  //     message: "请将本应用安装到桌面，以接收派单提醒。",
  //   });
  //   return;
  // }

  // **如果权限已经是 `granted`，直接订阅 Web Push，不弹窗**
  if (Notification.permission === "granted") {
    console.log("✅ 通知权限已授权，直接订阅 Web Push");
    await subscribeToPush();
    return;
  }

  // **如果权限不是 `granted`，弹窗引导用户开启**
  showConfirmDialog({
    title: "开启通知权限",
    message: "📢 请允许通知权限，以接收派单提醒",
    confirmButtonText: "允许",
    cancelButtonText: "拒绝",
  }).then(async () => {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      console.log("✅ 通知权限已授权");
      await subscribeToPush();
    } else {
      showDialog({
        title: "⚠️ 通知被拒绝",
        message: "你拒绝了通知权限，可能无法收到派单提醒。",
      });
      console.log("❌ 用户拒绝了通知权限");
    }
  }).catch(() => {
    console.log("❌ 用户取消了通知权限请求");
  });
};
